var map = {
	"./doc1.jpg": 9754,
	"./doc2.jpg": 9158,
	"./doc3.jpg": 652,
	"./doc4.jpg": 155,
	"./doc5.jpg": 414,
	"./doc6.jpg": 163,
	"./doc7.jpg": 6252,
	"./doc8.jpg": 7488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1074;